import {layer} from '@wandb/components';
import {Icon} from '@wandb/weave/components/Icon';
import styled from 'styled-components';

import {GLOBAL_COLORS} from '../../util/colors';

// Positioned portal that anchors the menu at the text caret. Replaces the
// legacy WBPopup portal/positioning; kept non-modal so the Slate editor keeps
// focus while the user keeps typing to filter after "/".
export const PopupContainer = styled.div`
  position: fixed;
  z-index: ${layer('menu')};
  pointer-events: auto;
  overflow-y: auto;
`;

export const Item = styled.div<{hovered?: boolean}>`
  color: white;
  padding: 8px 24px 8px 12px;
  font-size: 14px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  background: ${props =>
    props.hovered ? GLOBAL_COLORS.primary.toString() : 'none'};
  word-break: break-word;
`;

export const ItemLabel = styled.span`
  margin-right: 8px;
`;

export const ItemIcon = styled(Icon)`
  margin-left: 2px;
  margin-right: 14px;
  font-size: 20px;
  width: 16px;
  flex-shrink: 0;
`;
